import { createSelector } from "reselect";
import { Category } from "../../../@types/Category";
import { Template } from "../../../@types/template";
import { User } from "../../../@types/user";
import { RootState } from "../../rootReducer";

export const selectFormData = createSelector(
  [
    (store: RootState) => store.massiveDocumentCreate.document,
    (store: RootState) => store.massiveDocumentCreate.legalRep,
    (store: RootState) => store.massiveDocumentCreate.selectedTemplate,
    (store: RootState) => store.massiveDocumentCreate.creationType,
  ],
  (document, legalRep, template, creationType: string) =>
    ({
      ...document,
      legalRep,
      template,
      creationType,
      archive: document.archive,             // ✅ aquí lo agregas explícitamente
      archiveFilename: document.archiveFilename, // opcional, si lo usas también
    } as {
      creationType: string;
      title: string;
      category: Category;
      legalRep: User;
      template: Template;
      archive?: any;
      archiveFilename?: string;
    })
);
